import { Container, Card, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "../../styles/dualEducation.css";

export default function ThanksPageRetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const formType = location.state?.formType || "Általános";

  const getThanksMessage = () => {
    switch (formType) {
      case "Jelzáloghitel":
        return {
          title: "Köszönjük érdeklődését!",
          body: "Szakértő kollégánk 24 órán belül felveszi Önnel a kapcsolatot, és segít a jelzáloghitel-ajánlatok összehasonlításában.",
        };
      case "Személyi kölcsön":
        return {
          title: "Köszönjük érdeklődését!",
          body: "Kollégánk hamarosan keresni fogja Önt a megadott elérhetőségeken a személyi kölcsön ajánlatokkal kapcsolatban.",
        };
      case "Lakossági bankszámla":
        return {
          title: "Köszönjük érdeklődését!",
          body: "Munkatársunk 24 órán belül felveszi Önnel a kapcsolatot a lakossági bankszámla-ajánlatok részleteivel.",
        };
      case "Nyugdíjmegtakarítás":
        return {
          title: "Köszönjük érdeklődését!",
          body: "Kollégánk hamarosan jelentkezik, hogy segítsen a legmegfelelőbb nyugdíjmegtakarítási forma kiválasztásában.",
        };
      case "Kockázati életbiztosítás":
        return {
          title: "Köszönjük érdeklődését!",
          body: "Szakértő kollégánk 24 órán belül felveszi Önnel a kapcsolatot a kockázati életbiztosítási ajánlatokkal kapcsolatban.",
        };
      default:
        return {
          title: "Köszönjük!",
          body: "Adatait megkaptuk, kollégánk hamarosan keresni fogja a megadott elérhetőségeken.",
        };
    }
  };

  const message = getThanksMessage();

  return (
    <Container
      className="hero d-flex justify-content-center align-items-center"
      style={{ minHeight: "60vh" }}
    >
      <Card
        className="card px-4 py-5 text-center shadow-lg"
        style={{ maxWidth: "600px" }}
      >
        <div className="mb-4">
          <div
            className="rounded-circle bg-success d-inline-flex align-items-center justify-content-center"
            style={{ width: "80px", height: "80px" }}
          >
            <FontAwesomeIcon
              icon={faCheck}
              style={{ color: "white", fontSize: "40px" }}
            />
          </div>
        </div>
        <h1 className="h2 mb-3">{message.title}</h1>
        <p className="lead mb-4">{message.body}</p>
        <div className="cta justify-content-center">
          <Button className="btn btn-primary" onClick={() => navigate("/")}>
            Vissza a főoldalra
          </Button>
        </div>
      </Card>
    </Container>
  );
}
